import type { FunctionComponent, ReactNode } from 'react';

import * as styles from './SkipToContent.css';

interface Props {
  children: ReactNode;
}

export const SkipToContent: FunctionComponent<Props> = ({ children }) => (
  <a className={styles.root} href="#start-of-content">
    {children}
  </a>
);
